export default __webpack_public_path__ + "static/media/3.495803ed.jpg";